<script>

export default {
  name: "KycTab",
  props: {
    index: {
      type: [String, Number],
      required: true
    },
    text: {
      type: String,
      required: true
    },
    active: Boolean,
  },
  methods: {
    selectTab() {
      this.$emit('selectTab', this.index)
    }
  }
}
</script>

<template>
  <div class="contract-tab" :class="{
  'active': active
}" @click="selectTab">
    <div>
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.contract-tab {
  color: var(--text-primary-color);
  font-size: 14px;
  font-weight: 700;
  height: 50px;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
  background-color: var(--sidebar-background);
  padding-left: 12px;
  opacity: .7;
  text-align: center;
  align-content: center;

  &.active {
    opacity: 1;
    box-shadow: 0 -10px 10px -10px var(--text-primary-color);
  }
}
</style>